import { isTottusStandalone, updateCartQtyLimits } from '@digital-retail/store-manager';
import apiConfig from '../../config/api/apiConfig';
import { CookieStorage } from '../CookieStorage';
import { httpService } from '../httpService';
import { Logger } from '../Logger';
import { getCommerceHeaders } from '../tenantHelper';
import { mapProduct, segregateCollection } from './helpers';

export const removeCollectionCommerce =
  ({ cart, setCart }) =>
  async ({ appCtx, products }) => {
    const { regionCode, store } = appCtx;
    const cartId = CookieStorage.getCookie('cartId');
    const { OFFER_PRICE_LABEL, NORMAL_PRICE_LABEL } = appCtx?.siteConfig?.textDictionary ?? {};
    const toggles = appCtx?.siteConfig?.toggles ?? {};
    const isTottusSA = isTottusStandalone(store);

    const patchCart = products.map(({ cartLineId, totalQuantity }) => ({
      op: 'replace',
      path: `${cartLineId}/quantityNumber`,
      value: totalQuantity - 1,
    }));
    const reqBody = {
      data: {
        cart: {
          patchCart,
        },
      },
      metadata: {
        politicalAreaId: appCtx.politicalId,
        priceGroup: appCtx.priceGroupId,
      },
    };

    const additionalHeaders = getCommerceHeaders(regionCode, true, appCtx.url, appCtx.store);

    const patchCartLineUrl = apiConfig.patchCartlineCommerceUrl(cartId, regionCode);

    const response = await httpService().patch(
      patchCartLineUrl,
      reqBody,
      {
        credentials: 'include',
      },
      additionalHeaders,
      'json'
    );
    if (isTottusSA && response.statusCode === 200) {
      updateCartQtyLimits(response);
    }

    const { data, statusCode } = response;
    const items = data?.data?.cart?.cartLines ?? [];

    const totalProductsQuantityCount = data?.data?.cart?.totalProductsQuantityCount ?? 0;
    const totalProductsCount = totalProductsQuantityCount;

    if (statusCode === 200 && items) {
      const mappedProducts = items.map((item) =>
        mapProduct(item, regionCode, { OFFER_PRICE_LABEL, NORMAL_PRICE_LABEL }, toggles)
      );
      const mappedItems = segregateCollection({
        mappedProducts,
        collection: cart.typeACollections,
        action: 'REMOVE',
        products: [],
        cartItems: cart.cartItems,
      });

      setCart({
        ...cart,
        ...mappedItems,
        totalProductsCount,
      });
    } else {
      const { errors } = response;
      Logger.error(`Failed to Remove Product ${JSON.stringify(products)}`);
      return errors || [];
    }
    return null;
  };
